import React from 'react';
import { Reveal } from './Reveal';
import { Counter } from './Counter';

const stats = [
  { end: 10, suffix: '+', label: 'Années d’expérience' },
  { end: 4, suffix: '', label: 'Pôles d’expertise' },
  { end: 24, suffix: 'h', label: 'Délai de réponse moyen' },
];

export const StatsSection = () => (
  <section className="py-20 bg-primary-blue">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
        {stats.map((stat, i) => (
          <Reveal key={stat.label} delay={i * 120} className="text-center md:text-left">
            <p className="font-heading text-6xl md:text-7xl font-light text-white leading-none">
              <Counter end={stat.end} suffix={stat.suffix} />
            </p>
            <div className="w-12 h-px bg-warm-accent my-5 mx-auto md:mx-0" />
            <p className="text-sm uppercase tracking-[0.18em] text-white/60">{stat.label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
